<template>
  <div v-cloak class="right_col" role="main">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <el-row :gutter="20">
      <el-col :span="24">
        <h3>客服行為</h3>
        <hr />
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <h4>起始時間：</h4>
        <DateSelect ref="startTime"></DateSelect>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <h4>結束時間：</h4>
        <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
      </el-col>
    </el-row>
    <hr />
    <el-row :gutter="20" type="flex" align="middle">
      <el-col :span="5">
        <h4>客服人員:</h4>
        <el-select v-model="mangerSelect" placeholder="所有">
          <el-option
            v-for="(item, index) in managerList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <h4>操作種類:</h4>
        <el-select v-model="operationSelect" placeholder="所有">
          <el-option
            v-for="(item, index) in operation_type"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click.prevent="getOperation(1)">
          搜尋行為
        </el-button>
        <el-button type="danger" @click.prevent="clear">清除資料</el-button>
      </el-col>
    </el-row>
    <hr />
    <el-row :gutter="20">
      <el-col :span="24">
        <el-table style="width: 100%" :data="data">
          <el-table-column prop="type" label="操作種類"></el-table-column>
          <el-table-column label="事件說明">
            <template slot-scope="scope">
              <!-- 分行處理 -->
              <template
                v-if="scope.row.note && String(scope.row.note).includes('&&')"
              >
                <div
                  v-for="(line, index) in formatNote(scope.row.note)"
                  :key="index"
                >
                  {{ line }}
                </div>
              </template>
              <!-- 沒用&&分隔的話就直接顯示原本的 -->
              <template v-else>
                {{ scope.row.note }}
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作人員"></el-table-column>
          <el-table-column label="操作時間">
            <template slot-scope="scope">
              <span>{{ transferDate(scope.row.created) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="event" label="動作"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" :offset="17">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paging.totalEntries"
          :page-size="25"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import DateSelect from '@/components/tool/DateSelect'
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'

export default {
  components: {
    DateSelect,
  },
  data() {
    return {
      data: [],
      managerList: [],
      mangerSelect: '所有',
      operationSelect: '所有',
      paging: [],
      startTime: '',
      endTime: '',
      urlAPI: '',
      operation_type: [
        { value: '所有', label: '所有' },
        { value: '派車頁面', label: '派車頁面' },
        { value: '司機資料', label: '司機資料' },
        { value: '司機軌跡', label: '司機軌跡' },
        { value: '司機列表', label: '司機列表' },
        { value: '新增司機頁面', label: '新增司機頁面' },
        { value: '編輯司機頁面', label: '編輯司機頁面' },
        { value: '服務浮動框', label: '服務浮動框' },
        { value: '地標編輯', label: '地標編輯' },
        { value: '特約商家', label: '特約商家' },
        { value: '交叉路口', label: '交叉路口' },
        { value: '派遣單查詢', label: '派遣單查詢' },
        { value: '後派單', label: '後派單' },
        { value: '儲值管理', label: '儲值管理' },
        { value: '修改電子簽單', label: '修改電子簽單' },
        { value: '排班看板', label: '排班看板' },
        { value: '排班站', label: '排班站' },
        { value: '派遣區', label: '派遣區' },
        { value: '乘客資料', label: '乘客資料' },
      ],
      isLoading: false,
    }
  },
  mounted() {
    this.getManagerList()
    this.getOperation()
  },
  methods: {
    getManagerList() {
      API.get('behavior/category')
        .then((res) => {
          /* console.log(res) */
          this.managerList = res.result.managerNameList
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getOperation(current_page = 1) {
      this.isLoading = true
      const startTime = new Date(this.$refs.startTime.getDate())
      const endTime = new Date(this.$refs.endTime.getDate())
      startTime.setUTCHours(startTime.getUTCHours() - 8)
      endTime.setUTCHours(endTime.getUTCHours() - 8)
      const newstartTime = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
      const newendTime = dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
      let apiUrl = `behavior?start_date=${newstartTime}&end_date=${newendTime}&current_page=${current_page}&per_page=25`
      if (startTime > endTime) {
        this.$msg('「起始日期」不能大於「結束日期」')
      }
      if (this.mangerSelect != '所有') {
        apiUrl += `&name=${this.mangerSelect}`
      }
      if (this.operationSelect != '所有') {
        apiUrl += `&type=${this.operationSelect}`
      }
      API.get(apiUrl)
        .then((res) => {
          /* console.log(res) */
          this.data = res.result.data
          this.paging = res.result.paging
          this.isLoading = false
        })
        .catch((e) => {
          console.error(e)
        })
    },
    handleCurrentChange(value) {
      this.getOperation(value)
    },
    transferDate(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    clear() {
      this.data = []
      ;(this.mangerSelect = '所有'), (this.operationSelect = '所有')
    },
    formatNote(text) {
      // console.log('text:', text)
      // 如果沒有文字，返回空陣列
      if (!text) return ['']

      if (Array.isArray(text)) {
        text = text.join('')
      }
      // 使用者紀錄那邊會用&&做字串切割 這裡改掉的話記得要同步修改
      text = String(text).replace(/^\+/g, '').replace(/\+&&/g, '&&')
      return text
        .split('&&')
        .map((line) => line.trim())
        .filter((line) => line !== '')
    },
  },
}
</script>
<style scoped>
h4 {
  display: inline-block;
  letter-spacing: 1.2px;
}

input {
  margin: 0 5px;
}

.el-pagination {
  margin: 10px 0;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/LoginInfoList.vue